module.exports = __webpack_public_path__ + "img/plan-2-1.4adfd7c6.png";